
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sluzby",
      function () {
        return require("private-next-pages/sluzby.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sluzby"])
      });
    }
  